import React from 'react'
import _ from 'lodash';
import moment from 'moment';
import FlexView from 'react-flexview';
import PrintIcon from 'material-ui/svg-icons/action/print';
import ArrowDropDownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import BackspaceIcon from 'material-ui/svg-icons/content/backspace';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Slider from "react-slick";
import RaisedButton from 'material-ui/RaisedButton';
import uuid from 'node-uuid';
import QRCode from "qrcode.react";
import ReactPlayer from 'react-player';
import * as SocketIO from "../common/SocketIO.js";
import * as DataAPI from "../common/DataAPI.js";
import Dialogs from "../common/Dialogs.js";
import * as history from '../common/history.js';
import constants from "../common/constants";
import * as raspberry from "../common/raspberry.js";
import ReactToPrint from "../common/reactToPrint.js";
import * as qrCodeReader from '../common/qrCodeReader';
import Sound from "react-sound";

const SECONDS_TO_SHOW_ERROR_LAYER = 5;
const MAX_NO_OF_STUDENTS = 4;
const MAX_PHONE_NO_LENGTH = 8;
const MIN_PHONE_NO_LENGTH = 8;
const MAX_ORDER_NO_LENGTH = 15;
const DEFAULT_COUNTRY_DIAL = '852';
const DEFAULT_NO_OF_STUDENT = 0;
const DEFAULT_PHONE_NUMBER = '';
const DEFAULT_EMAIL = '';
const DEFAULT_ORDER_NO = '';
const EMPTY_INPUT = {
  countryDial: DEFAULT_COUNTRY_DIAL,
  noOfStudent: DEFAULT_NO_OF_STUDENT,
  phoneNumber: DEFAULT_PHONE_NUMBER,
  email: DEFAULT_EMAIL,
  orderNo: DEFAULT_ORDER_NO,
};
const STEP_FIELDS = [{
  step: 3,
  field: 'shouldInputNoOfStudent',
}, {
  step: 4,
  field: 'shouldInputPhoneNo',
}, {
  step: 5,
  field: 'shouldInputEmail',
}, {
  step: 6,
  field: 'shouldInputOrderNo',
}];
const MAX_QR_CODE_LENGTH = 17;
const firstStepNumber = 0;

const DEVICE = 'keypad';
const keyCodeMapping = DEVICE === 'keypad' ? {
  // 96: '0', //NUM LOCK
  // 97: '1', //NUM LOCK
  // 98: '2', //NUM LOCK
  // 99: '3', //NUM LOCK
  // 100: '4', //NUM LOCK
  // 101: '5', //NUM LOCK
  // 102: '6', //NUM LOCK
  // 103: '7', //NUM LOCK
  // 104: '8', //NUM LOCK
  // 105: '9', //NUM LOCK
  //
  // 45: '0', //NOT NUM LOCK
  // 35: '1', //NOT NUM LOCK
  // 40: '2', //NOT NUM LOCK
  // 34: '3', //NOT NUM LOCK
  // 37: '4', //NOT NUM LOCK
  // 12: '5', //NOT NUM LOCK
  // 39: '6', //NOT NUM LOCK
  // 36: '7', //NOT NUM LOCK
  // 38: '8', //NOT NUM LOCK
  // 33: '9', //NOT NUM LOCK

  48: '0', //Scan Barcode
  49: '1', //Scan Barcode
  50: '2', //Scan Barcode
  51: '3', //Scan Barcode
  52: '4', //Scan Barcode
  53: '5', //Scan Barcode
  54: '6', //Scan Barcode
  55: '7', //Scan Barcode
  56: '8', //Scan Barcode
  57: '9', //Scan Barcode

  65: 'a', //Scan Barcode
  66: 'b', //Scan Barcode
  67: 'c', //Scan Barcode
  68: 'd', //Scan Barcode
  69: 'e', //Scan Barcode
  70: 'f', //Scan Barcode
  71: 'g', //Scan Barcode
  72: 'h', //Scan Barcode
  73: 'i', //Scan Barcode
  74: 'j', //Scan Barcode
  75: 'k', //Scan Barcode
  76: 'l', //Scan Barcode
  77: 'm', //Scan Barcode
  78: 'n', //Scan Barcode
  79: 'o', //Scan Barcode
  80: 'p', //Scan Barcode
  81: 'q', //Scan Barcode
  82: 'r', //Scan Barcode
  83: 's', //Scan Barcode
  84: 't', //Scan Barcode
  85: 'u', //Scan Barcode
  86: 'v', //Scan Barcode
  87: 'w', //Scan Barcode
  88: 'x', //Scan Barcode
  89: 'y', //Scan Barcode
  90: 'z', //Scan Barcode

  13: 'enter',
  // 27: 'esc',
  // 8: 'backspace',
  // 111: 'left',
  // 106: 'right',
  // 107: 'plus',
  // 109: 'minus',
  // 183: 'nurse',
  // 9: 'staff',
  // 46: 'language',
} : {
  48: '0',
  49: '1',
  50: '2',
  51: '3',
  52: '4',
  53: '5',
  54: '6',
  55: '7',
  56: '8',
  57: '9',
  79: 'o',
  80: 'p',
  13: 'enter',
  27: 'esc',
  8: 'backspace',
  189: 'minus',
  187: 'plus',
  37: 'left',
  39: 'right',
  190: 'language',
  186: 'nurse',
  222: 'staff',
};

class ComponentToPrint extends React.Component {
  constructor(props) {
    super();

  }

  render() {
    return (
      <div style={{
        width: 270,
      }}>
        <div style={{
          width: '100%',
          textAlign: 'center',
        }}>
          <img style={{
            height: 60,
          }} src='/images/ticket-logo.png' />
        </div>

        <FlexView style={{
          marginTop: 10,
        }}>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div style={{ 'fontSize': 11, textAlign: 'center' }}>Please note the queuing info as
              shown on the Display
            </div>
          </FlexView>
        </FlexView>
        <FlexView>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div style={{ 'fontSize': 10 }}>請留意熒光幕上所顯示之輪候資料</div>
          </FlexView>
        </FlexView>
        <FlexView>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div
              style={{ 'fontSize': 60 }}>{_.get(this, 'props.ticket.queue.code') + _.get(this, 'props.ticket.ticketNumber')}</div>
          </FlexView>
        </FlexView>
        <FlexView style={{
          marginTop: 10,
        }}>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div style={{ 'fontSize': 11, textAlign: 'center' }}>Please obtain a new ticket if you
              miss your queuing no.
              by 5 nos. or more
            </div>
          </FlexView>
        </FlexView>
        <FlexView>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div style={{ 'fontSize': 10 }}>若錯過5個輪候號碼或以上，請重新拿取輪候券。</div>
          </FlexView>
        </FlexView>
        <FlexView style={{
          marginTop: 15,
        }}>
          <FlexView column vAlignContent='center' hAlignContent='center' width='100%'>
            <div style={{ 'fontSize': 10 }}>
              {
                'Date日期:' + _.get(this, 'props.ticket.createdDate') +
                ' ' + 'Time時間:' + _.get(this, 'props.ticket.createdTime')
              }
            </div>
          </FlexView>
        </FlexView>
        {
          _.get(this, 'props.ticket.qrCode') &&
          <div>
            <div>
              ---------------------------------------
            </div>
            <FlexView>
              <FlexView vAlignContent='center' width='55%'>
                {/*<div style={{ 'fontSize': 10, marginLeft: 30, }}>Powered By :</div>*/}
                <div>
                  <div style={{ 'fontSize': 11, textAlign: 'center' }}>
                    Scan the QR code with your mobile phone to see the latest queue status
                  </div>
                  <div style={{ 'fontSize': 12, textAlign: 'center' }}>使用您的手機掃瞄二維碼</div>
                  <div style={{ 'fontSize': 12, textAlign: 'center' }}>以查看最新排隊狀況</div>
                </div>
              </FlexView>
              <FlexView hAlignContent='center'>
                <QRCode
                  size={110}
                  value={_.get(this, 'props.ticket.qrCode', '')} />
              </FlexView>
            </FlexView>
          </div>
        }
        <div style={{
          marginTop: '10px',
        }}>
          <div style={{ 'fontSize': 9, textAlign: 'center' }}>Powered By Lemon Dice Studio</div>
        </div>
        {/*{*/}
        {/*  constants.showLDLogoInTicket &&*/}
        {/*  <div>*/}
        {/*    <FlexView>*/}
        {/*      <FlexView vAlignContent='center' width='45%'>*/}
        {/*        <div style={{ 'fontSize': 10, marginLeft: 30, }}>Powered By :</div>*/}
        {/*      </FlexView>*/}
        {/*      <FlexView hAlignContent='center'>*/}
        {/*        <img*/}
        {/*          width='120'*/}
        {/*          height='45'*/}
        {/*          src='/images/lemondice.png' />*/}
        {/*      </FlexView>*/}
        {/*    </FlexView>*/}
        {/*  </div>*/}
        {/*}*/}
      </div>
    );
  }
}

class KioskDisplay1920x1080 extends React.Component {
  constructor(props) {
    super();
    this.state = {
      displayQueues: [],
      queues: [],
      isTicketPrinting: false,
      shouldShowLayer: false,
      printingJobId: uuid.v4(),
      ticketToPrint: {
        createdDate: moment().format('YYYY-MM-DD'),
        createdTime: moment().format('HH:mm:ss'),
        ticketNumber: 0,
        queue: null,
      },
      displayId: _.get(props.match.params, 'displayId'),
      display: null,
      isJobQueueRunning: false,
      jobQueue: [],
      sound: {
        urls: [],
        urlToPlay: '',
        status: Sound.status.PLAYING,
        position: 0,
        volume: 100, //[0,100]
      },
      player: {
        id: 0,
        urls: [],
        urlToPlay: '',
        volume: 0, // [0,1]
      },
      advMediaTypeToShow: '',
      heartbeatTimer: null,
      numberOfTicketPrinted: 0,
      lastActionTime: null,
      layerErrMsg: {
        zhTW: '',
        en: '',
      },
      layerTimer: null,
      homeTimer: null,
      shouldShowErrorLayer: false,
      secondsToHideErrorLayer: 0,
      secondsToBackHome: 0,
      currentStep: firstStepNumber, // 0 = reserved / non-reserved, 1 = choose queue, 2 = scan qrcode, 3= input number of student, 4 = input phone number, 5 = input email, 6 = input order no.
      isEnableQrCodeScanning: false,
      queueSelected: null,
      // countryDialSelected: DEFAULT_COUNTRY_DIAL,
      // phoneNumberInputted: DEFAULT_PHONE_NUMBER,
      shouldOpenCountryListLayer: false,
      input: EMPTY_INPUT,
      isMachineValid: false,
      barcodeInputted: '',
    };

    this.showErrorLayer = this.showErrorLayer.bind(this);
    this.createTicket = this.createTicket.bind(this);
    this.onBeforeTicketPrint = this.onBeforeTicketPrint.bind(this);
    this.onAfterTicketPrint = this.onAfterTicketPrint.bind(this);
    this.playNextSound = this.playNextSound.bind(this);
    this.playNextVideo = this.playNextVideo.bind(this);
    this.refreshVideoPlayer = this.refreshVideoPlayer.bind(this);
    this.onVideoPlayEnded = this.onVideoPlayEnded.bind(this);
    this.flashQueueTicket = this.flashQueueTicket.bind(this);
    this.execJobQueue = this.execJobQueue.bind(this);
    this.selectClass = this.selectClass.bind(this);
    this.backToFirstStep = this.backToFirstStep.bind(this);
    this.selectQueue = this.selectQueue.bind(this);
    this.inputPhoneNumber = this.inputPhoneNumber.bind(this);
    this.backspacePhoneNumber = this.backspacePhoneNumber.bind(this);
    this.clearPhoneNumber = this.clearPhoneNumber.bind(this);
    this.openCountryListLayer = this.openCountryListLayer.bind(this);
    this.closeCountryListLayer = this.closeCountryListLayer.bind(this);
    this.selectCountry = this.selectCountry.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.clearEmail = this.clearEmail.bind(this);
    this.clearOrderNo = this.clearOrderNo.bind(this);
    this.isPhoneNumberInvalid = this.isPhoneNumberInvalid.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.backspaceEmail = this.backspaceEmail.bind(this);
  }

  async componentWillMount() {
    const isMachineValid = constants.isMachineValid();

    if (!isMachineValid) return;

    this.refreshDisplayQueues();
    this.refreshQueueList();
    this.refreshDisplay();
    this.updateLayer();

    this.setState({
      isMachineValid,
    });

    // if (!IS_RASPBERRY) {


    // return;
    // }
    //
    // try {
    //   await raspberry.init();
    //   raspberry.onVideoPlayEnded(({ playerId }) => {
    //     if (playerId === this.state.player.id) {
    //       this.onVideoPlayEnded();
    //     }
    //   });
    //   raspberry.onVideoPlayFail(({ playerId }) => {
    //     console.log('onVideoPlayFail');
    //     if (playerId === this.state.player.id) {
    //       this.onVideoPlayEnded();
    //     }
    //   });
    //
    //   raspberry.onAudioPlayEnded(({}) => {
    //     // this.playNextSound();
    //   });
    //   raspberry.onAudioPlayFail(({}) => {
    //     console.log('onAudioPlayFail');
    //     // this.playNextSound();
    //   });
    //
    //   raspberry.startHeartbeat();
    //
    //   const heartbeatTimer = setInterval(() => {
    //     raspberry.heartbeat();
    //   }, 10000);
    //
    //   this.setState({ heartbeatTimer });
    //
    //   this.refreshQueueList();
    // this.refreshDisplay();
    // } catch (err) {
    //   console.error('componentWillMount error:', err);
    // }
  }

  componentDidMount() {
    const isMachineValid = constants.isMachineValid();

    if (!isMachineValid) return;

    // if (IS_PRODUCTION) {
    //   qrCodeReader.init(this.backToFirstStep);
    //
    //   qrCodeReader.setSocketClosedEvent(() => {
    //     qrCodeReader.init(this.backToFirstStep);
    //   });
    //   console.log('start!!!');
    //   qrCodeReader.addMsgReceiveEvent((data) => {
    //     console.log('qrcode:', data);
    //
    //
    //     setTimeout(() => {
    //       // const data = 'd7756584686529111';
    //
    //       if (this.state.isEnableQrCodeScanning && this.state.currentStep === 2 && !this.state.shouldShowLayer && !this.state.shouldShowErrorLayer) {
    //         this.disableQrCodeScanning(() => {
    //           this.updateLastActionTime();
    //
    //           const qrCodeNo = data;
    //
    //           DataAPI.put(`/api/display/createdTicketByQrCode/${qrCodeNo}`, {}, (err, ticket) => {
    //             this.startToCountBackHomeTime(2);
    //
    //             if (err) {
    //               return this.showErrorLayer(_.get(err, 'errors[0].message'), SECONDS_TO_SHOW_ERROR_LAYER);
    //             }
    //           });
    //         });
    //       }
    //     }, 2000);
    //   });
    // }

    const layerTimer = setInterval(() => {
      if (this.state.secondsToHideErrorLayer && moment().diff(this.state.lastActionTime, 'seconds') >= this.state.secondsToHideErrorLayer) {
        this.stopToCountErrorLayerTime();
        this.hideErrorLayer();
      }
    }, 1000);

    const homeTimer = setInterval(() => {
      if (this.state.secondsToBackHome && moment().diff(this.state.lastActionTime, 'seconds') >= this.state.secondsToBackHome) {
        this.stopToCountBackHomeTime();
        this.backToFirstStep();
      }
    }, 1000);

    this.setState({ layerTimer, homeTimer });

    SocketIO.on('refresh', () => {
      location.reload();
    });

    SocketIO.on('calling', ({ ticketToCall }) => {
      const job = (cb) => {
        _.set(ticketToCall, 'ticketNumber', this.formatTicketNumber(ticketToCall.number));
        this.updateQueueTicketNumber(ticketToCall);
        this.callTicket(ticketToCall);
        this.flashQueueTicket(ticketToCall.queue, cb);

        // if (this.state.display.flashLight) {
        SocketIO.emit('flashLight', {
          counterName: ticketToCall.counter.name,
        });
        // }
      };

      this.pushJobToQueue({ job });
    });

    SocketIO.on('printTicket', ({ queue, number, createdAt, qrCodeContent, printingJobId }) => {
      if (_.size(printingJobId) && printingJobId !== this.state.printingJobId) return false;

      const createdDate = moment(createdAt).format('YYYY-MM-DD');
      const createdTime = moment(createdAt).format('HH:mm');
      const ticketNumber = this.formatTicketNumber(number);

      let qrCode;

      if (qrCodeContent) {
        const {
          queueStatusDomain,
          queueStatusTheme,
          onlineDeviceId,
          onlineQueueId,
          lang,
        } = qrCodeContent;
        qrCode = `${queueStatusDomain}/${queueStatusTheme}/${onlineDeviceId}/${onlineQueueId}/${queue.code}${ticketNumber}`
        if (_.size(lang)) qrCode += `?lang=${lang}`;
      }

      this.setState({
        ticketToPrint: {
          queue,
          createdDate,
          createdTime,
          ticketNumber,
          qrCode,
        },
      }, () => {
        this.setState({
          numberOfTicketPrinted: 0,
          isTicketPrinting: true,
        }, () => {
          this.startToCountBackHomeTime(2);
          this.printer.handlePrint();

          setTimeout(() => {
            this.setState({
              isTicketPrinting: false,
            });
          }, 3000);
        });
      });
    });

    SocketIO.on('updateKioskLayer', () => {
      this.updateLayer();
    });

    SocketIO.on('refreshDisplay', ({ displayId }) => {
      this.refreshDisplay();
    });

    SocketIO.on('refreshQueue', ({}) => {
      this.refreshQueueList();
      this.refreshDisplayQueues();
    });

    SocketIO.on('refresh', () => {
      this.refreshQueueList();
      this.refreshDisplayQueues();
    });

    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    // if (IS_RASPBERRY) {
    //   raspberry.endHeartbeat();
    //   clearInterval(this.state.heartbeatTimer);
    // }
  }

  handleKeyDown({ keyCode }) {
    console.log('keyCode:', keyCode);
    const input = keyCodeMapping[keyCode] || '';

    console.log('input:', input);

    console.log('this.state.barcodeInputted:', this.state.barcodeInputted);
    if (_.size(this.state.barcodeInputted) && input === 'enter') {
      const qrCodeNo = this.state.barcodeInputted;

      this.clearBarcodeInputted();

      if (this.state.isEnableQrCodeScanning && this.state.currentStep === 2 && !this.state.shouldShowLayer && !this.state.shouldShowErrorLayer) {
        this.disableQrCodeScanning(() => {
          this.updateLastActionTime();

          DataAPI.put(`/api/display/createdTicketByQrCode/${qrCodeNo}`, {}, (err, ticket) => {
            this.startToCountBackHomeTime(4);

            if (err) {
              return this.showErrorLayer(_.get(err, 'errors[0].message'), SECONDS_TO_SHOW_ERROR_LAYER);
            }
          });
        });
      }
    } else if (_.size(input)) {
      this.setState((prevState) => {
        const barcodeInputted = prevState.barcodeInputted + input;
        if (_.size(barcodeInputted) > MAX_QR_CODE_LENGTH) return false;

        return {
          barcodeInputted,
        }
      });
    }
  }

  clearBarcodeInputted() {
    this.setState({
      barcodeInputted: '',
    });
  }

  formatTicketNumber(number) {
    return _.padStart(number, 3, '0');
  }

  pushJobToQueue({ job, shouldExecuteNextJob = true }, cb = constants.emptyFnc) {
    const self = this;

    this.setState((prevState) => {
      let jobQueue = prevState.jobQueue;
      jobQueue.push(job);

      return { jobQueue };
    }, () => {
      if (shouldExecuteNextJob && !self.state.isJobQueueRunning) self.execJobQueue();

      cb();
    });
  }

  execJobQueue() {
    if (!_.size(this.state.jobQueue)) {
      this.setState({ isJobQueueRunning: false });

      return;
    }

    let jobQueue = _.concat(this.state.jobQueue);
    const job = jobQueue.shift();

    this.setState({ jobQueue, isJobQueueRunning: true }, () => {
      job(this.execJobQueue);
    });
  }

  onBeforeTicketPrint() {
    // this.setState({
    //   isTicketPrinting: true,
    // });
  }

  onAfterTicketPrint() {
    let { numberOfTicketPrinted } = this.state;

    numberOfTicketPrinted = numberOfTicketPrinted + 1;

    if (numberOfTicketPrinted < this.state.display.numberOfTicketToPrint) {
      this.setState({
        numberOfTicketPrinted,
      }, this.printer.handlePrint);
    } else {
      this.setState({
        numberOfTicketPrinted,
        // isTicketPrinting: false,
      });
    }
  }

  updateLastActionTime() {
    this.setState({
      lastActionTime: moment(),
    });
  }

  updateLayer(cb = constants.emptyFnc) {
    DataAPI.get(`/api/display/allowGetTicket`, {}, (err, isAllowGetTicket) => {
      if (err) return console.error('updateLayer error:', JSON.stringify(err));

      this.setState({
        shouldShowLayer: !isAllowGetTicket,
      }, cb);
    });
  }

  nextStep() {
    let nextStep = this.getNextStepNumber();

    if (!nextStep) return this.createTicket(this.state.queueSelected, this.state.input);

    this.setState({
      currentStep: nextStep,
    });
  }

  selectQueue(queue) {
    this.updateLastActionTime();
    this.setState({
      queueSelected: queue,
    }, this.nextStep);
  }

  updateInputAndNextStep(field, value) {
    this.updateLastActionTime();
    this.updateInputState(field, value, this.nextStep);
  }

  getNextStepNumber() {
    const ordersToCheck = _.filter(STEP_FIELDS, item => {
      return item.step > this.state.currentStep;
    });
    let nextStepNumber = _.get(_.head(ordersToCheck), 'step');
    let numberToReturn;

    _.forEach(ordersToCheck, order => {
      if (this.state.queueSelected.kiosk[order.field]) {
        numberToReturn = nextStepNumber;
        return false;
      }

      nextStepNumber++;
    });

    return numberToReturn;
  }

  showErrorLayer(errMsg, seconds) {
    this.setState({
      shouldShowErrorLayer: true,
      layerErrMsg: errMsg,
    }, this.startToCountErrorLayerTime(seconds));
  }

  startToCountErrorLayerTime(seconds) {
    this.setState({
      lastActionTime: moment(),
      secondsToHideErrorLayer: seconds,
    });
  }

  stopToCountErrorLayerTime() {
    this.setState({
      secondsToHideErrorLayer: 0,
    });
  }

  hideErrorLayer() {
    this.setState({
      shouldShowErrorLayer: false,
      layerErrMsg: {},
    });
  }

  startToCountBackHomeTime(seconds) {
    this.setState({
      lastActionTime: moment(),
      secondsToBackHome: seconds,
    });
  }

  stopToCountBackHomeTime() {
    this.setState({
      secondsToBackHome: 0,
    });
  }

  enableQrCodeScanning(cb = constants.emptyFnc) {
    this.setState({
      isEnableQrCodeScanning: true,
    }, cb);
  }

  disableQrCodeScanning(cb = constants.emptyFnc) {
    this.setState({
      isEnableQrCodeScanning: false,
    }, cb);
  }

  selectClass(isReserved) {
    const nextStep = isReserved === 'Y' ? 2 : 1;

    this.setState({
      currentStep: nextStep,
    }, () => {
      // if (nextStep === 2 && IS_PRODUCTION && qrCodeReader.isInited()) {
      //   qrCodeReader.lightOn();
      // }

      if (nextStep === 2 && IS_PRODUCTION) {
        this.enableQrCodeScanning();
      }

      this.startToCountBackHomeTime(20);
    })
  }

  refreshDisplayQueues() {
    DataAPI.get('/api/display/queuesCalling', {}, (err, queues) => {
      if (err) return console.error('get queueList error:', JSON.stringify(err));

      queues = _.map(queues, queue => {
        return _.assign(queue, {
          ticketNumber: this.formatTicketNumber(_.get(queue, 'lastCalledTicket.number')),
          // counterName: _.get(queue, 'lastCalledTicket.counter.name'),
        });
      });

      this.setState({
        displayQueues: queues,
      });
    });
  }

  refreshDisplay(cb = constants.emptyFnc) {
    DataAPI.get(`/api/display/${this.state.displayId}`, {}, (err, display) => {
      if (err) return console.error('get display error:', JSON.stringify(err));

      // let sound = _.cloneDeep(this.state.sound);
      // sound.volume = display.callingVolume;

      this.setState({
        display,
        // sound,
      }, () => {
        this.refreshAdvMediaBlock();
        cb();
      });
    });
  }

  refreshQueueList() {
    DataAPI.get('/api/display/queues', {}, (err, queues) => {
      if (err) return console.error('get queues error:', JSON.stringify(err));

      this.setState({
        queues,
      });
    });
  }

  getAdvPosition() {
    return _.cloneDeep(_.find(this.state.display.advPositions, { row: 0 }));
  }

  createTicket(queue, input) {
    this.setState({ isTicketPrinting: true }, () => {
      DataAPI.put(`/api/kiosk/${queue._id}/createTicket`, _.omitBy({
        // countryDial: input.countryDial,
        noOfStudent: input.noOfStudent,
        phoneNumber: input.phoneNumber,
        email: input.email,
        orderNo: input.orderNo,
        printingJobId: this.state.printingJobId,
      }, _.isNil), (err, ticket) => {
        setTimeout(() => {
          this.setState({ isTicketPrinting: false });
          this.backToFirstStep();
        }, 2000);

        if (err) return this.dialogs.error(err);
      });
    });

  }

  refreshAdvMediaBlock() {
    let advMediaTypeToShow = this.state.advMediaTypeToShow === 'photo' ? 'video' : 'photo';
    const advPosition = this.getAdvPosition();

    if (advMediaTypeToShow === 'photo' && !_.size(_.get(advPosition, 'photos', []))) {
      advMediaTypeToShow = 'video';
    }

    if (advMediaTypeToShow === 'video' && !_.size(_.get(advPosition, 'videos', []))) {
      advMediaTypeToShow = 'photo';
    }

    this.setState({
      advMediaTypeToShow,
    }, () => {
      if (advMediaTypeToShow === 'video') this.refreshVideoPlayer();
    });
  }

  inputPhoneNumber(number) {
    this.updateLastActionTime();
    let phoneNumberInputted = this.state.input.phoneNumber;

    if (_.size(phoneNumberInputted) >= MAX_PHONE_NO_LENGTH) return;

    phoneNumberInputted += number;

    this.updateInputState('phoneNumber', phoneNumberInputted);
  }

  isPhoneNumberInvalid() {
    return _.size(this.state.input.phoneNumber) && _.size(this.state.input.phoneNumber) < MIN_PHONE_NO_LENGTH;
  }

  backspaceEmail() {
    this.updateLastActionTime();
    let emailInputted = this.state.input.email;

    emailInputted = _.join(_.dropRight(_.split(emailInputted, '')), '');

    this.updateInputState('email', emailInputted);
  }

  inputEmail(letter) {
    this.updateLastActionTime();
    let emailInputted = this.state.input.email;

    if (letter === '－') letter = '-';

    emailInputted += letter;

    this.updateInputState('email', emailInputted);
  }

  isEmailInvalid() {
    const email = this.state.input.email;

    if (!_.size(email)) return false;

    return !email.match(/.+@.+\..+/);
  }

  inputOrderNo(number) {
    this.updateLastActionTime();
    let orderNoInputted = this.state.input.orderNo;

    if (_.size(orderNoInputted) >= MAX_ORDER_NO_LENGTH) return;

    orderNoInputted += number;

    this.updateInputState('orderNo', orderNoInputted);
  }

  isOrderNoInvalid() {
    return !_.size(this.state.input.orderNo);
  }

  backspacePhoneNumber() {
    let phoneNumberInputted = this.state.phoneNumberInputted;

    phoneNumberInputted = _.join(_.dropRight(_.split(phoneNumberInputted, '')), '');

    this.setState({
      phoneNumberInputted,
    });
  }

  clearPhoneNumber() {
    this.updateLastActionTime();
    this.updateInputState('phoneNumber', DEFAULT_PHONE_NUMBER);
  }

  clearEmail() {
    this.updateLastActionTime();
    this.updateInputState('email', DEFAULT_EMAIL);
  }

  clearOrderNo() {
    this.updateLastActionTime();
    this.updateInputState('orderNo', DEFAULT_ORDER_NO);
  }

  openCountryListLayer() {
    this.setState({
      shouldOpenCountryListLayer: true,
    });
  }

  closeCountryListLayer() {
    this.setState({
      shouldOpenCountryListLayer: false,
    });
  }

  updateQueueTicketNumber(ticket) {
    const displayQueues = _.map(_.cloneDeep(this.state.displayQueues), queue => {
      if (ticket.queue.code === queue.code) {
        _.assign(queue, {
          ticketNumber: ticket.ticketNumber,
          counterName: _.get(ticket, 'counter.name'),
        })
      }

      return queue;
    });

    this.setState({
      displayQueues,
    });
  }

  createCallingSoundUrls(ticket) {
    const numbersToFindSound = _.chain(ticket.ticketNumber)
      .toString()
      .map(_.toNumber) // split into 1 digit
      .value();

    let soundUrls = ['/audios/' + _.get(_.find(constants.callingSounds, { type: 'ding' }), 'fileName')];

    // Queue id, eg.A,B,C,D
    soundUrls.push('/audios/' + _.get(_.find(constants.callingSounds, {
      type: ticket.queue.code,
    }), 'fileName'));

    // Ticket no.
    soundUrls = _.concat(soundUrls, _.map(numbersToFindSound, number => {
      return '/audios/' + _.get(_.find(constants.callingSounds, {
        type: number,
        lang: 'en',
      }), 'fileName');
    }));

    if (IS_PRODUCTION) {
      soundUrls = _.map(soundUrls, (url) => {
        return (constants.audioDomainPath || window.location.origin) + url;
      });
    }

    return soundUrls;
  }

  playNextSound() {
    let sound = { ...this.state.sound };

    const urls = sound.urls;

    // if (IS_RASPBERRY || IS_TINKER) {
    //   // Play all sound file urls
    //   raspberry.playAudio({
    //     urls,
    //   });
    // } else {
    const urlToPlay = urls.shift() || '';

    _.assign(sound, {
      urls,
      urlToPlay,
      position: 0,
    });

    setTimeout(() => {
      this.setState({ sound });
    }, 100);
    // }
  }

  flashQueueTicket(queueToFlash, cb = constants.emptyFnc) {
    let callingTimer;
    let count = 0;
    callingTimer = setInterval(() => {
      if (count > 9) {
        clearInterval(callingTimer);
        return cb();
      }

      count++;

      const displayQueues = _.map(_.cloneDeep(this.state.displayQueues), displayQueue => {
        if (queueToFlash.code === displayQueue.code) {
          _.set(displayQueue, 'isCalling', !displayQueue.isCalling);
        }

        return displayQueue;
      });
      this.setState({ displayQueues });
    }, 400);
  }

  callTicket(ticket) {
    const sound = {
      ...this.state.sound,
      urls: this.createCallingSoundUrls(ticket),
      urlToPlay: '',
    };

    this.setState({
      sound
    }, this.playNextSound);
  }

  refreshVideoPlayer() {
    const advPosition = this.getAdvPosition();
    let urls;

    if (IS_RASPBERRY) {
      urls = _.map(advPosition.videos, (video) => {
        return window.location.origin + video.url;
      });
    } else {
      urls = _.map(advPosition.videos, 'url');
    }

    let player = { ...this.state.player, urls, urlToPlay: '' };

    this.setState({ player }, this.playNextVideo);
  }

  playNextVideo() {
    const player = { ...this.state.player };

    player.urlToPlay = player.urls.shift() || '';
    this.setState({ player });

    if (IS_RASPBERRY && _.size(player.urlToPlay)) {
      raspberry.playVideo({
        playerId: player.id,
        urls: [player.urlToPlay],
        winPositions: {
          x1: 533,
          y1: 190,
          x2: 1920,
          y2: 970,
        },
        volume: 0,
      });
    }
  }

  onVideoPlayEnded() {
    if (_.size(this.state.player.urls)) {
      this.playNextVideo();
    } else {
      this.refreshAdvMediaBlock();
    }
  }

  // nextStep() {
  //   this.setState((prevState) => {
  //     return {
  //       currentStep: prevState.currentStep + 1,
  //     }
  //   });
  // }

  backToFirstStep() {
    console.log('backToFirstStep');
    this.setState({
      currentStep: firstStepNumber,
    }, () => {
      // if (IS_PRODUCTION && qrCodeReader.isInited()) {
      //   qrCodeReader.lightOff();
      // }

      this.clearSelectedData();
      this.disableQrCodeScanning();
      this.hideErrorLayer();
    });
  }

  clearSelectedData() {
    this.setState({
      queueSelected: null,
      input: EMPTY_INPUT,
    });
  }

  selectCountry(country) {
    this.setState({
      countryDialSelected: country.dial,
    });

    this.closeCountryListLayer();
  }

  updateInputState(field, value, cb = constants.emptyFnc) {
    const input = _.cloneDeep(this.state.input);

    _.set(input, field, value);

    this.setState({
      input,
    }, cb);
  }

  render() {
    const self = this;
    const settings = {
      fade: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
    };

    const largeSliderSettings = _.assign({}, settings, {
      beforeChange: (oldIndex, newIndex) => {
        if (newIndex === 0) {
          setTimeout(() => {
            self.refreshAdvMediaBlock();
          });
        }
      },
    });

    return (
      <div className="kiosk-display-1920x1080-container">
        {
          this.state.isMachineValid &&
          <div>
            <div className="queues-calling-block">
              {
                _.map(this.state.displayQueues, (displayQueue, index) => (
                  <div key={index}
                       className={(displayQueue.isCalling ? 'calling ' : '') + "calling-block"}
                       style={{
                         backgroundColor: constants.styles.queueItems[index].ticketNumber.backgroundColor,
                         color: constants.styles.queueItems[index].ticketNumber.fontColor,
                       }}>{displayQueue.code + displayQueue.ticketNumber}
                  </div>
                ))
              }
            </div>

            <div className="media-block">
              {
                this.state.advMediaTypeToShow === 'photo' &&
                <div className="image-block">
                  <Slider {...largeSliderSettings}>
                    {
                      _.map(_.get(this.getAdvPosition(), 'photos', []), (photo, index) => (
                        <div key={index}>
                          <div className="image"
                               style={{
                                 backgroundImage: `url('${photo.url}')`
                               }} />
                        </div>
                      ))
                    }
                  </Slider>
                </div>
              }
              {
                this.state.advMediaTypeToShow === 'video' && !IS_RASPBERRY &&
                <ReactPlayer
                  url={this.state.player.urlToPlay}
                  volume={this.state.player.volume}
                  onEnded={this.onVideoPlayEnded}
                  onError={this.onVideoPlayEnded}
                  playing
                  width={'100%'}
                  height={'100%'}
                />
              }
            </div>

            {
              this.state.shouldShowLayer &&
              <div className="layer-block">
                <div className="pause-layer">
                  <div className="text-en">QUEUING PAUSED</div>
                  <div className="text-chi">暫停取票</div>
                </div>
              </div>
            }
            {
              this.state.isTicketPrinting &&
              <div className="printing-block">
                <PrintIcon className="icon" />
                <div className="text-en">TICKET IS PRINTING</div>
                <div className="text-chi">籌號列印中</div>
              </div>
            }
            {
              this.state.shouldShowErrorLayer &&
              <div className="error-layer-block">
                <div className="text-en">
                  {_.size(this.state.layerErrMsg.en) ? this.state.layerErrMsg.en : 'Error occurred, please ask our staff for assistance'}
                </div>
                <div className="text-chi">
                  {_.size(this.state.layerErrMsg.zhTW) ? this.state.layerErrMsg.zhTW : '發生錯誤，請找職員協助。'}
                </div>
              </div>
            }
            {
              this.state.currentStep === 0 &&
              <div className="class-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="class-header">
                      <div className="en-name">HAVE YOU MADE APPOINTMENT?</div>
                      <div className="zhtw-name">你已網上預約了嗎？</div>
                      <img src="/images/tap-icon.png" />
                    </div>
                    <div className="options-block">
                      <div className="option-block"
                           onClick={IS_PRODUCTION ? constants.emptyFnc : this.selectClass.bind(this, 'N')}
                           onTouchEnd={IS_PRODUCTION ? this.selectClass.bind(this, 'N') : constants.emptyFnc}>
                        <div className="en-name">NO</div>
                        <div className="zhtw-name">沒有預約</div>
                      </div>
                      <div className="option-block"
                           onClick={IS_PRODUCTION ? constants.emptyFnc : this.selectClass.bind(this, 'Y')}
                           onTouchEnd={IS_PRODUCTION ? this.selectClass.bind(this, 'Y') : constants.emptyFnc}>
                        <div className="en-name">YES</div>
                        <div className="zhtw-name">已預約</div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            }
            {
              this.state.currentStep === 1 &&
              <div className="queues-block">
                <div className="select-block">
                  <div className="queue-list">
                    <div className="queue-header">
                      <div className="en-name">CHOOSE YOUR SERVICE</div>
                      <div className="zhtw-name">選擇你的服務</div>
                      <img src="/images/tap-icon.png" />
                    </div>
                    <div className="all-queues-block">
                      {
                        _.map(this.state.queues, (queue, index) => (
                          <div className="queue-item" key={index}
                               style={{
                                 borderColor: constants.styles.queueItems[index].ticketNumber.backgroundColor,
                               }}
                               onClick={IS_PRODUCTION ? constants.emptyFnc : this.selectQueue.bind(this, queue)}
                               onTouchEnd={IS_PRODUCTION ? this.selectQueue.bind(this, queue) : constants.emptyFnc}>
                            <img src={`/images/${queue.logoName}`} />
                            <div className="en-name">{queue.name.en}</div>
                            <div className="zhtw-name">{queue.name.zhTW}</div>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
                <div className="back-btn-block">
                  <div className="back-btn"
                       onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                       onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                    <div className="btn-text-chi">取消</div>
                    <div className="btn-text-en">Cancel</div>
                  </div>
                </div>

              </div>
            }
            {
              this.state.currentStep === 2 &&
              <div className="qrcode-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="qrcode-header">
                      <div className="en-name">SCAN THE QR CODE IN THE EMAIL BELOW</div>
                      <div className="zhtw-name">在下方掃描預約電郵裡的二維碼</div>
                    </div>
                    <img src="/images/qrcode-logo.jpeg" />
                  </div>
                </div>
                <div className="cancel-block"
                     onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                     onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                  <div className="en-name">CANCEL</div>
                  <div className="zhtw-name">取消</div>
                </div>
              </div>
            }
            {
              this.state.currentStep === 3 &&
              <div className="student-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="header">
                      <div className="en-name">SELECT NUMBER OF STUDENT</div>
                      <div className="zhtw-name">選擇小朋友數量</div>
                      <img src="/images/tap-icon.png" />
                    </div>
                    <div className="options-block">
                      {
                        _.map(_.range(MAX_NO_OF_STUDENTS), index => (
                          <div key={index} className="option-block"
                               onClick={IS_PRODUCTION ? constants.emptyFnc : this.updateInputAndNextStep.bind(this, 'noOfStudent', index + 1)}
                               onTouchEnd={IS_PRODUCTION ? this.updateInputAndNextStep.bind(this, 'noOfStudent', index + 1) : constants.emptyFnc}>
                            {index + 1}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
                <div className="cancel-block"
                     onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                     onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                  <div className="en-name">CANCEL</div>
                  <div className="zhtw-name">取消</div>
                </div>
              </div>
            }
            {
              this.state.currentStep === 4 &&
              <div className="phone-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="header">
                      <div className="en-name">INPUT YOUR PHONE NUMBER</div>
                      <div className="zhtw-name">輸入你的聯絡電話</div>
                      <img src="/images/tap-icon.png" />
                    </div>

                    <div className="phone-no">{this.state.input.phoneNumber}</div>

                    <div className="keypad-block">
                      {
                        _.map(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'], (number, index) => (
                          <div key={index} className="key-block"
                               onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputPhoneNumber.bind(this, number)}
                               onTouchEnd={IS_PRODUCTION ? this.inputPhoneNumber.bind(this, number) : constants.emptyFnc}>
                            {number}
                          </div>
                        ))
                      }
                      <div className="key-block reset-key"
                           onClick={IS_PRODUCTION ? constants.emptyFnc : this.clearPhoneNumber}
                           onTouchEnd={IS_PRODUCTION ? this.clearPhoneNumber : constants.emptyFnc}>
                        RESET
                      </div>
                      <div className={(this.isPhoneNumberInvalid() ? 'invalid ' : '') + "key-block"}
                           onClick={IS_PRODUCTION ? constants.emptyFnc : (!this.isPhoneNumberInvalid() && this.nextStep)}
                           onTouchEnd={IS_PRODUCTION ? (!this.isPhoneNumberInvalid() && this.nextStep) : constants.emptyFnc}>
                        <CheckIcon className="icon tick-icon" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cancel-block"
                     onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                     onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                  <div className="en-name">CANCEL</div>
                  <div className="zhtw-name">取消</div>
                </div>
              </div>
            }
            {
              this.state.currentStep === 5 &&
              <div className="email-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="header">
                      <div className="en-name">INPUT YOUR EMAIL</div>
                      <div className="zhtw-name">輸入你的電郵地址</div>
                      <img src="/images/tap-icon.png" />
                    </div>

                    <div className="email">{this.state.input.email}</div>

                    <div className="keypad-block">
                      <div className="numbers-block">
                        {
                          _.map(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'], (letter, index) => (
                            <div key={index} className="key-block"
                                 onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputEmail.bind(this, letter)}
                                 onTouchEnd={IS_PRODUCTION ? this.inputEmail.bind(this, letter) : constants.emptyFnc}>
                              {letter}
                            </div>
                          ))
                        }
                      </div>
                      <div className="numbers-block" style={{}}>
                        {
                          _.map(['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'], (letter, index) => (
                            <div key={index} className="key-block"
                                 onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputEmail.bind(this, letter)}
                                 onTouchEnd={IS_PRODUCTION ? this.inputEmail.bind(this, letter) : constants.emptyFnc}>
                              {letter}
                            </div>
                          ))
                        }
                      </div>
                      <div className="numbers-block" style={{
                        // paddingLeft: '52px',
                      }}>
                        {
                          _.map(['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '@'], (letter, index) => (
                            <div key={index} className="key-block"
                                 onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputEmail.bind(this, letter)}
                                 onTouchEnd={IS_PRODUCTION ? this.inputEmail.bind(this, letter) : constants.emptyFnc}>
                              {letter}
                            </div>
                          ))
                        }
                      </div>
                      <div className="numbers-block" style={{
                        // paddingLeft: '52px',
                      }}>
                        {
                          _.map(['Z', 'X', 'C', 'V', 'B', 'N', 'M', '.', '－', '_'], (letter, index) => (
                            <div key={index} className="key-block"
                                 onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputEmail.bind(this, letter)}
                                 onTouchEnd={IS_PRODUCTION ? this.inputEmail.bind(this, letter) : constants.emptyFnc}>
                              {letter}
                            </div>
                          ))
                        }
                      </div>
                      <div className="numbers-block" style={{
                        // paddingLeft: '52px',
                      }}>
                        {
                          _.map(['GMAIL.COM', 'YAHOO.COM', 'OUTLOOK.COM', 'HOTMAIL.COM'], (letter, index) => (
                            <div key={index} className="key-block address"
                                 onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputEmail.bind(this, letter)}
                                 onTouchEnd={IS_PRODUCTION ? this.inputEmail.bind(this, letter) : constants.emptyFnc}>
                              {letter}
                            </div>
                          ))
                        }
                      </div>

                      <div className="action-block">
                        <div className="button-block reset-key"
                             onClick={IS_PRODUCTION ? constants.emptyFnc : this.backspaceEmail}
                             onTouchEnd={IS_PRODUCTION ? this.backspaceEmail : constants.emptyFnc}>
                          DELETE
                        </div>
                        <div
                          className={(this.isEmailInvalid() ? 'invalid ' : '') + "button-block enter-key"}
                          onClick={IS_PRODUCTION ? constants.emptyFnc : (!this.isEmailInvalid() && this.nextStep)}
                          onTouchEnd={IS_PRODUCTION ? (!this.isEmailInvalid() && this.nextStep) : constants.emptyFnc}>
                          <CheckIcon className="icon tick-icon" />
                          <div className="text">ENTER</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cancel-block"
                     onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                     onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                  <div className="en-name">CANCEL</div>
                  <div className="zhtw-name">取消</div>
                </div>
              </div>
            }
            {
              this.state.currentStep === 6 &&
              <div className="order-no-block">
                <div className="select-block">
                  <div className="main-block">
                    <div className="header">
                      <div className="en-name">INPUT YOUR ORDER NUMBER</div>
                      <div className="zhtw-name">輸入你的訂單號碼</div>
                      <img src="/images/tap-icon.png" />
                    </div>

                    <div className="phone-no">{this.state.input.orderNo}</div>

                    <div className="keypad-block">
                      {
                        _.map(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'], (number, index) => (
                          <div key={index} className="key-block"
                               onClick={IS_PRODUCTION ? constants.emptyFnc : this.inputOrderNo.bind(this, number)}
                               onTouchEnd={IS_PRODUCTION ? this.inputOrderNo.bind(this, number) : constants.emptyFnc}>
                            {number}
                          </div>
                        ))
                      }
                      <div className="key-block reset-key"
                           onClick={IS_PRODUCTION ? constants.emptyFnc : this.clearOrderNo}
                           onTouchEnd={IS_PRODUCTION ? this.clearOrderNo : constants.emptyFnc}>
                        RESET
                      </div>
                      <div className={(this.isOrderNoInvalid() ? 'invalid ' : '') + "key-block"}
                           onClick={IS_PRODUCTION ? constants.emptyFnc : (!this.isOrderNoInvalid() && this.nextStep)}
                           onTouchEnd={IS_PRODUCTION ? (!this.isOrderNoInvalid() && this.nextStep) : constants.emptyFnc}>
                        <CheckIcon className="icon tick-icon" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cancel-block"
                     onClick={IS_PRODUCTION ? constants.emptyFnc : this.backToFirstStep}
                     onTouchEnd={IS_PRODUCTION ? this.backToFirstStep : constants.emptyFnc}>
                  <div className="en-name">CANCEL</div>
                  <div className="zhtw-name">取消</div>
                </div>
              </div>
            }

            <Dialogs onInit={dialog => (this.dialogs = dialog)} />
            {
              // !IS_RASPBERRY && !IS_TINKER &&
              <Sound
                url={this.state.sound.urlToPlay}
                playStatus={this.state.sound.status}
                playFromPosition={this.state.sound.position /* in milliseconds */}
                volume={this.state.sound.volume}
                onFinishedPlaying={this.playNextSound}
              />
            }
            <ReactToPrint
              onInit={printer => (
                this.printer = printer
              )}
              content={() => this.componentRef}
              onBeforePrint={this.onBeforeTicketPrint}
              onAfterPrint={this.onAfterTicketPrint}
            />
            <ComponentToPrint ticket={this.state.ticketToPrint} style={{ 'display': 'none' }}
                              ref={el => (this.componentRef = el)} />
          </div>
        }
      </div>
    );
  }
}

export default KioskDisplay1920x1080;



// WEBPACK FOOTER //
// client/display/KioskDisplay-1920x1080.js